/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ManualOrderStatus } from './ManualOrderStatus';
import {
    ManualOrderStatusFromJSON,
    ManualOrderStatusFromJSONTyped,
    ManualOrderStatusToJSON,
    ManualOrderStatusToJSONTyped,
} from './ManualOrderStatus';
import type { OrderBigGoodsVo } from './OrderBigGoodsVo';
import {
    OrderBigGoodsVoFromJSON,
    OrderBigGoodsVoFromJSONTyped,
    OrderBigGoodsVoToJSON,
    OrderBigGoodsVoToJSONTyped,
} from './OrderBigGoodsVo';
import type { BoxPalletInfoVo } from './BoxPalletInfoVo';
import {
    BoxPalletInfoVoFromJSON,
    BoxPalletInfoVoFromJSONTyped,
    BoxPalletInfoVoToJSON,
    BoxPalletInfoVoToJSONTyped,
} from './BoxPalletInfoVo';
import type { SubIvcWaybillVo } from './SubIvcWaybillVo';
import {
    SubIvcWaybillVoFromJSON,
    SubIvcWaybillVoFromJSONTyped,
    SubIvcWaybillVoToJSON,
    SubIvcWaybillVoToJSONTyped,
} from './SubIvcWaybillVo';
import type { OrderBigTableKoreaTrackVo } from './OrderBigTableKoreaTrackVo';
import {
    OrderBigTableKoreaTrackVoFromJSON,
    OrderBigTableKoreaTrackVoFromJSONTyped,
    OrderBigTableKoreaTrackVoToJSON,
    OrderBigTableKoreaTrackVoToJSONTyped,
} from './OrderBigTableKoreaTrackVo';
import type { CombinSplitFromVo } from './CombinSplitFromVo';
import {
    CombinSplitFromVoFromJSON,
    CombinSplitFromVoFromJSONTyped,
    CombinSplitFromVoToJSON,
    CombinSplitFromVoToJSONTyped,
} from './CombinSplitFromVo';

/**
 * 
 * @export
 * @interface OrderBigTablePageResVo
 */
export interface OrderBigTablePageResVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    id?: number;
    /**
     * 是否已经创建工单
     * @type {boolean}
     * @memberof OrderBigTablePageResVo
     */
    hasTicket?: boolean;
    /**
     * 工单ID，对应ticket.id；未创建工单时为空
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    ticketId?: number;
    /**
     * 对外工单编号；未创建工单时为空
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    ticketNo?: string;
    /**
     * 工单状态：1进行中、2已关闭；未创建工单时为空
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    ticketStatus?: number;
    /**
     * 订单行索引
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    rowIndex?: number;
    /**
     * 订单描述  代买服务还是转运服务，页面上显示在订单号上方
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    orderDescription?: string;
    /**
     * 订单号
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    code?: string;
    /**
     * 服务类型
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    requestGroup?: string;
    /**
     * 申请类型
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    requestType?: string;
    /**
     * 仓库名称
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    warehouseName?: string;
    /**
     * 运输方式名称
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    transportMethodName?: string;
    /**
     * 国际运输方式：1海运 2空运 3LCL海运 4FCL海运，取中国仓出库运单，不随韩国 Tab 改成国内运输方式
     * 国际运输方式：1海运 2空运 3LCL海运 4FCL海运
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    internationalTransportMethodId?: number;
    /**
     * 运单打印页路径码：k空运面单 t海运面单，对应 /general/waybill-print/{code}
     * 运单打印页路径码：k空运 t海运
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    waybillPrintTemplate?: string;
    /**
     * 用户ID
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    userId?: number;
    /**
     * 用户名称
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    userName?: string;
    /**
     * 用户编码
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    userCode?: string;
    /**
     * 接收人姓名
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    receiverName?: string;
    /**
     * 操作员ID
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    workerId?: number;
    /**
     * 操作员所在部门ID
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    workerDepartmentId?: number;
    /**
     * 操作员姓名
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    workerName?: string;
    /**
     * 采购员ID
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    purchaserId?: number;
    /**
     * 采购员姓名
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    purchaserName?: string;
    /**
     * 客服ID
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    customerServiceId?: number;
    /**
     * 客服姓名
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    customerServiceName?: string;
    /**
     * 商品总数
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    goodsTotalQuantity?: number;
    /**
     * 订单总价
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    goodsTotalAmount?: number;
    /**
     * 订单总价（美元）
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    goodsTotalAmountUsd?: number;
    /**
     * 清关方式 1 企业 2 个人
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    ctmsType?: number;
    /**
     * 结算方式
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    paymentMethod?: string;
    /**
     * 最近的账单金额
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    lastBillPrice?: number;
    /**
     * IVC号
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    ivc?: string;
    /**
     * 国际运输运单号列表，主运单在前、子运单随后
     * @type {Array<string>}
     * @memberof OrderBigTablePageResVo
     */
    internationalTrackingNumbers?: Array<string>;
    /**
     * 运输公司编码
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    transportCompanyCode?: string;
    /**
     * 运输公司名称
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    transportCompanyName?: string;
    /**
     * 子单号信息列表
     * @type {Array<SubIvcWaybillVo>}
     * @memberof OrderBigTablePageResVo
     */
    subIvcWaybillVOList?: Array<SubIvcWaybillVo>;
    /**
     * 列表出库日期。有出库计划=计划日；无计划且已出库完成=进入出库完成当天。前端列表只展示这个字段，不要用 expectedOutboundDate 顶替。
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    chinaOutboundDate?: string;
    /**
     * 韩国IVC号
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    koreaIvc?: string;
    /**
     * 韩国出库日期
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    koreaOutboundDate?: string;
    /**
     * 仍在出库计划中的计划日。移出计划或确认出库后为空。不是列表出库日期。
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    expectedOutboundDate?: string;
    /**
     * 包装状态  已包装/未包装
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    packageStatus?: string;
    /**
     * 包装状态编码：0-未包装，1-已包装
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    packageStatusCode?: number;
    /**
     * 唛头号
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    markNo?: string;
    /**
     * 货位号
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    locationCode?: string;
    /**
     * coupang入库日期
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    coupangInboundDate?: string;
    /**
     * coupang仓库ID
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    coupangWarehouseId?: number;
    /**
     * coupang仓库名称
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    coupangWarehouseName?: string;
    /**
     * coupang商户名称
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    coupangMerchantName?: string;
    /**
     * coupang入库号
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    coupangInboundNo?: string;
    /**
     * 下单时间
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    updateTime?: string;
    /**
     * 附加服务名称
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    additionalServiceName?: string;
    /**
     * 仓库要求事项
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    remark?: string;
    /**
     * 中国仓库备注
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    warehouseRemarkCN?: string;
    /**
     * 韩国仓库备注
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    warehouseRemarkKR?: string;
    /**
     * 订单状态名称
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    orderStatusName?: string;
    /**
     * 订单状态码
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    orderStatusCode?: number;
    /**
     * 韩国运输方式ID  入coupang仓库的那段运输
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    krLocalTransportMethodId?: number;
    /**
     * 总箱数
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    totalBoxCount?: number;
    /**
     * 总托盘数
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    totalPalletCount?: number;
    /**
     * 总CBM
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    totalCBM?: number;
    /**
     * 当前国家ID
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    currentNationId?: number;
    /**
     * 购买类型 1 代买服务 2 转运服务
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    buyType?: number;
    /**
     * 当前仓库ID
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    currentWarehouseId?: number;
    /**
     * 出库计划表实时计划日，用于判断是否仍在计划中、跳转计划页。不是列表出库日期。
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    outboundPlanDate?: string;
    /**
     * 账单类型
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    billType?: number;
    /**
     * 账单类型名称
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    billTypeName?: string;
    /**
     * 账单状态
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    billStatus?: number;
    /**
     * 账单状态名称
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    billStatusName?: string;
    /**
     * 账单编码
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    billCode?: string;
    /**
     * 代买取消时订单状态名称
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    proxyBuyCancelOrderStatusName?: string;
    /**
     * BL号
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    blNo?: string;
    /**
     * 返送处理方式
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    returnFromCoupangProcessMethod?: number;
    /**
     * 订单类型
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    orderType?: number;
    /**
     * 退货出库日期
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    returnOutboundDate?: string;
    /**
     * 退货单号
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    returnTrackingNumber?: string;
    /**
     * 退货方式 1 快递 2 货车
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    returnTransportMethod?: number;
    /**
     * 退货方式名称
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    returnTransportMethodName?: string;
    /**
     * 退货车牌号（货车退货）
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    returnTruckNumber?: string;
    /**
     * 退货联系方式（货车退货）
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    returnTruckContact?: string;
    /**
     * 出库方式id（韩国出库段主运单的国内运输方式，6=货车；与上传单号接口的货车判定同源）
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    outboundTransportMethodId?: number;
    /**
     * 出库车牌号（货车出库）
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    outboundTruckNumber?: string;
    /**
     * 出库联系方式（货车出库）
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    outboundTruckContact?: string;
    /**
     * 提货方式
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    takeGoodsMethod?: number;
    /**
     * 是否是首次订单
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    firstOrder?: number;
    /**
     * 分单合单原订单列表
     * @type {Array<CombinSplitFromVo>}
     * @memberof OrderBigTablePageResVo
     */
    combinSplitFroms?: Array<CombinSplitFromVo>;
    /**
     * 当前订单是基于哪个订单创建的  订单id
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    createFromOrderId?: number;
    /**
     * 当前订单是基于哪个订单创建的  订单编码
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    createFromOrderCode?: string;
    /**
     * 当前订单是基于哪个订单创建的  订单请求类型
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    createFromOrderRequestType?: string;
    /**
     * 3PL 是从哪个状态变成出库取消状态的
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    therePlCancelOrderStatus?: number;
    /**
     * 3PL 出库取消之前的状态的名称
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    therePlCancelOrderStatusName?: string;
    /**
     * 适用重量
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    applyValue?: number;
    /**
     * 单位
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    applyUnit?: string;
    /**
     * 实际重量
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    realWeight?: number;
    /**
     * 商品验收前确认要求项
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    requireBeforeAccept?: string;
    /**
     * 退货订单 取货方式1 仓库快递 2 卖家回收
     * @type {number}
     * @memberof OrderBigTablePageResVo
     */
    returnFetchGoodsMethod?: number;
    /**
     * 退货订单取货码
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    returnFetchGoodsCode?: string;
    /**
     * 退货订单取货时间
     * @type {string}
     * @memberof OrderBigTablePageResVo
     */
    returnFetchGoodsDate?: string;
    /**
     * 管理端按钮编码列表
     * @type {Array<string>}
     * @memberof OrderBigTablePageResVo
     */
    adminButtonCodes?: Array<string>;
    /**
     * 客户端按钮编码列表
     * @type {Array<string>}
     * @memberof OrderBigTablePageResVo
     */
    clientButtonCodes?: Array<string>;
    /**
     * 管理端手动订单状态列表
     * @type {Array<ManualOrderStatus>}
     * @memberof OrderBigTablePageResVo
     */
    adminManualOrderStatusList?: Array<ManualOrderStatus>;
    /**
     * 商品列表
     * @type {Array<OrderBigGoodsVo>}
     * @memberof OrderBigTablePageResVo
     */
    goodsList?: Array<OrderBigGoodsVo>;
    /**
     * 箱托盘信息
     * @type {Array<BoxPalletInfoVo>}
     * @memberof OrderBigTablePageResVo
     */
    boxPalletInfos?: Array<BoxPalletInfoVo>;
    /**
     * 韩国运输单列表
     * @type {Array<OrderBigTableKoreaTrackVo>}
     * @memberof OrderBigTablePageResVo
     */
    koreaTracks?: Array<OrderBigTableKoreaTrackVo>;
}

/**
 * Check if a given object implements the OrderBigTablePageResVo interface.
 */
export function instanceOfOrderBigTablePageResVo(value: object): value is OrderBigTablePageResVo {
    return true;
}

export function OrderBigTablePageResVoFromJSON(json: any): OrderBigTablePageResVo {
    return OrderBigTablePageResVoFromJSONTyped(json, false);
}

export function OrderBigTablePageResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderBigTablePageResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'hasTicket': json['hasTicket'] == null ? undefined : json['hasTicket'],
        'ticketId': json['ticketId'] == null ? undefined : json['ticketId'],
        'ticketNo': json['ticketNo'] == null ? undefined : json['ticketNo'],
        'ticketStatus': json['ticketStatus'] == null ? undefined : json['ticketStatus'],
        'rowIndex': json['rowIndex'] == null ? undefined : json['rowIndex'],
        'orderDescription': json['orderDescription'] == null ? undefined : json['orderDescription'],
        'code': json['code'] == null ? undefined : json['code'],
        'requestGroup': json['requestGroup'] == null ? undefined : json['requestGroup'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'transportMethodName': json['transportMethodName'] == null ? undefined : json['transportMethodName'],
        'internationalTransportMethodId': json['internationalTransportMethodId'] == null ? undefined : json['internationalTransportMethodId'],
        'waybillPrintTemplate': json['waybillPrintTemplate'] == null ? undefined : json['waybillPrintTemplate'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'workerId': json['workerId'] == null ? undefined : json['workerId'],
        'workerDepartmentId': json['workerDepartmentId'] == null ? undefined : json['workerDepartmentId'],
        'workerName': json['workerName'] == null ? undefined : json['workerName'],
        'purchaserId': json['purchaserId'] == null ? undefined : json['purchaserId'],
        'purchaserName': json['purchaserName'] == null ? undefined : json['purchaserName'],
        'customerServiceId': json['customerServiceId'] == null ? undefined : json['customerServiceId'],
        'customerServiceName': json['customerServiceName'] == null ? undefined : json['customerServiceName'],
        'goodsTotalQuantity': json['goodsTotalQuantity'] == null ? undefined : json['goodsTotalQuantity'],
        'goodsTotalAmount': json['goodsTotalAmount'] == null ? undefined : json['goodsTotalAmount'],
        'goodsTotalAmountUsd': json['goodsTotalAmountUsd'] == null ? undefined : json['goodsTotalAmountUsd'],
        'ctmsType': json['ctmsType'] == null ? undefined : json['ctmsType'],
        'paymentMethod': json['paymentMethod'] == null ? undefined : json['paymentMethod'],
        'lastBillPrice': json['lastBillPrice'] == null ? undefined : json['lastBillPrice'],
        'ivc': json['ivc'] == null ? undefined : json['ivc'],
        'internationalTrackingNumbers': json['internationalTrackingNumbers'] == null ? undefined : json['internationalTrackingNumbers'],
        'transportCompanyCode': json['transportCompanyCode'] == null ? undefined : json['transportCompanyCode'],
        'transportCompanyName': json['transportCompanyName'] == null ? undefined : json['transportCompanyName'],
        'subIvcWaybillVOList': json['subIvcWaybillVOList'] == null ? undefined : ((json['subIvcWaybillVOList'] as Array<any>).map(SubIvcWaybillVoFromJSON)),
        'chinaOutboundDate': json['chinaOutboundDate'] == null ? undefined : json['chinaOutboundDate'],
        'koreaIvc': json['koreaIvc'] == null ? undefined : json['koreaIvc'],
        'koreaOutboundDate': json['koreaOutboundDate'] == null ? undefined : json['koreaOutboundDate'],
        'expectedOutboundDate': json['expectedOutboundDate'] == null ? undefined : json['expectedOutboundDate'],
        'packageStatus': json['packageStatus'] == null ? undefined : json['packageStatus'],
        'packageStatusCode': json['packageStatusCode'] == null ? undefined : json['packageStatusCode'],
        'markNo': json['markNo'] == null ? undefined : json['markNo'],
        'locationCode': json['locationCode'] == null ? undefined : json['locationCode'],
        'coupangInboundDate': json['coupangInboundDate'] == null ? undefined : json['coupangInboundDate'],
        'coupangWarehouseId': json['coupangWarehouseId'] == null ? undefined : json['coupangWarehouseId'],
        'coupangWarehouseName': json['coupangWarehouseName'] == null ? undefined : json['coupangWarehouseName'],
        'coupangMerchantName': json['coupangMerchantName'] == null ? undefined : json['coupangMerchantName'],
        'coupangInboundNo': json['coupangInboundNo'] == null ? undefined : json['coupangInboundNo'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'additionalServiceName': json['additionalServiceName'] == null ? undefined : json['additionalServiceName'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'warehouseRemarkCN': json['warehouseRemarkCN'] == null ? undefined : json['warehouseRemarkCN'],
        'warehouseRemarkKR': json['warehouseRemarkKR'] == null ? undefined : json['warehouseRemarkKR'],
        'orderStatusName': json['orderStatusName'] == null ? undefined : json['orderStatusName'],
        'orderStatusCode': json['orderStatusCode'] == null ? undefined : json['orderStatusCode'],
        'krLocalTransportMethodId': json['krLocalTransportMethodId'] == null ? undefined : json['krLocalTransportMethodId'],
        'totalBoxCount': json['totalBoxCount'] == null ? undefined : json['totalBoxCount'],
        'totalPalletCount': json['totalPalletCount'] == null ? undefined : json['totalPalletCount'],
        'totalCBM': json['totalCBM'] == null ? undefined : json['totalCBM'],
        'currentNationId': json['currentNationId'] == null ? undefined : json['currentNationId'],
        'buyType': json['buyType'] == null ? undefined : json['buyType'],
        'currentWarehouseId': json['currentWarehouseId'] == null ? undefined : json['currentWarehouseId'],
        'outboundPlanDate': json['outboundPlanDate'] == null ? undefined : json['outboundPlanDate'],
        'billType': json['billType'] == null ? undefined : json['billType'],
        'billTypeName': json['billTypeName'] == null ? undefined : json['billTypeName'],
        'billStatus': json['billStatus'] == null ? undefined : json['billStatus'],
        'billStatusName': json['billStatusName'] == null ? undefined : json['billStatusName'],
        'billCode': json['billCode'] == null ? undefined : json['billCode'],
        'proxyBuyCancelOrderStatusName': json['proxyBuyCancelOrderStatusName'] == null ? undefined : json['proxyBuyCancelOrderStatusName'],
        'blNo': json['blNo'] == null ? undefined : json['blNo'],
        'returnFromCoupangProcessMethod': json['returnFromCoupangProcessMethod'] == null ? undefined : json['returnFromCoupangProcessMethod'],
        'orderType': json['orderType'] == null ? undefined : json['orderType'],
        'returnOutboundDate': json['returnOutboundDate'] == null ? undefined : json['returnOutboundDate'],
        'returnTrackingNumber': json['returnTrackingNumber'] == null ? undefined : json['returnTrackingNumber'],
        'returnTransportMethod': json['returnTransportMethod'] == null ? undefined : json['returnTransportMethod'],
        'returnTransportMethodName': json['returnTransportMethodName'] == null ? undefined : json['returnTransportMethodName'],
        'returnTruckNumber': json['returnTruckNumber'] == null ? undefined : json['returnTruckNumber'],
        'returnTruckContact': json['returnTruckContact'] == null ? undefined : json['returnTruckContact'],
        'outboundTransportMethodId': json['outboundTransportMethodId'] == null ? undefined : json['outboundTransportMethodId'],
        'outboundTruckNumber': json['outboundTruckNumber'] == null ? undefined : json['outboundTruckNumber'],
        'outboundTruckContact': json['outboundTruckContact'] == null ? undefined : json['outboundTruckContact'],
        'takeGoodsMethod': json['takeGoodsMethod'] == null ? undefined : json['takeGoodsMethod'],
        'firstOrder': json['firstOrder'] == null ? undefined : json['firstOrder'],
        'combinSplitFroms': json['combinSplitFroms'] == null ? undefined : ((json['combinSplitFroms'] as Array<any>).map(CombinSplitFromVoFromJSON)),
        'createFromOrderId': json['createFromOrderId'] == null ? undefined : json['createFromOrderId'],
        'createFromOrderCode': json['createFromOrderCode'] == null ? undefined : json['createFromOrderCode'],
        'createFromOrderRequestType': json['createFromOrderRequestType'] == null ? undefined : json['createFromOrderRequestType'],
        'therePlCancelOrderStatus': json['therePlCancelOrderStatus'] == null ? undefined : json['therePlCancelOrderStatus'],
        'therePlCancelOrderStatusName': json['therePlCancelOrderStatusName'] == null ? undefined : json['therePlCancelOrderStatusName'],
        'applyValue': json['applyValue'] == null ? undefined : json['applyValue'],
        'applyUnit': json['applyUnit'] == null ? undefined : json['applyUnit'],
        'realWeight': json['realWeight'] == null ? undefined : json['realWeight'],
        'requireBeforeAccept': json['requireBeforeAccept'] == null ? undefined : json['requireBeforeAccept'],
        'returnFetchGoodsMethod': json['returnFetchGoodsMethod'] == null ? undefined : json['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': json['returnFetchGoodsCode'] == null ? undefined : json['returnFetchGoodsCode'],
        'returnFetchGoodsDate': json['returnFetchGoodsDate'] == null ? undefined : json['returnFetchGoodsDate'],
        'adminButtonCodes': json['adminButtonCodes'] == null ? undefined : json['adminButtonCodes'],
        'clientButtonCodes': json['clientButtonCodes'] == null ? undefined : json['clientButtonCodes'],
        'adminManualOrderStatusList': json['adminManualOrderStatusList'] == null ? undefined : ((json['adminManualOrderStatusList'] as Array<any>).map(ManualOrderStatusFromJSON)),
        'goodsList': json['goodsList'] == null ? undefined : ((json['goodsList'] as Array<any>).map(OrderBigGoodsVoFromJSON)),
        'boxPalletInfos': json['boxPalletInfos'] == null ? undefined : ((json['boxPalletInfos'] as Array<any>).map(BoxPalletInfoVoFromJSON)),
        'koreaTracks': json['koreaTracks'] == null ? undefined : ((json['koreaTracks'] as Array<any>).map(OrderBigTableKoreaTrackVoFromJSON)),
    };
}

export function OrderBigTablePageResVoToJSON(json: any): OrderBigTablePageResVo {
    return OrderBigTablePageResVoToJSONTyped(json, false);
}

export function OrderBigTablePageResVoToJSONTyped(value?: OrderBigTablePageResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'hasTicket': value['hasTicket'],
        'ticketId': value['ticketId'],
        'ticketNo': value['ticketNo'],
        'ticketStatus': value['ticketStatus'],
        'rowIndex': value['rowIndex'],
        'orderDescription': value['orderDescription'],
        'code': value['code'],
        'requestGroup': value['requestGroup'],
        'requestType': value['requestType'],
        'warehouseName': value['warehouseName'],
        'transportMethodName': value['transportMethodName'],
        'internationalTransportMethodId': value['internationalTransportMethodId'],
        'waybillPrintTemplate': value['waybillPrintTemplate'],
        'userId': value['userId'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'receiverName': value['receiverName'],
        'workerId': value['workerId'],
        'workerDepartmentId': value['workerDepartmentId'],
        'workerName': value['workerName'],
        'purchaserId': value['purchaserId'],
        'purchaserName': value['purchaserName'],
        'customerServiceId': value['customerServiceId'],
        'customerServiceName': value['customerServiceName'],
        'goodsTotalQuantity': value['goodsTotalQuantity'],
        'goodsTotalAmount': value['goodsTotalAmount'],
        'goodsTotalAmountUsd': value['goodsTotalAmountUsd'],
        'ctmsType': value['ctmsType'],
        'paymentMethod': value['paymentMethod'],
        'lastBillPrice': value['lastBillPrice'],
        'ivc': value['ivc'],
        'internationalTrackingNumbers': value['internationalTrackingNumbers'],
        'transportCompanyCode': value['transportCompanyCode'],
        'transportCompanyName': value['transportCompanyName'],
        'subIvcWaybillVOList': value['subIvcWaybillVOList'] == null ? undefined : ((value['subIvcWaybillVOList'] as Array<any>).map(SubIvcWaybillVoToJSON)),
        'chinaOutboundDate': value['chinaOutboundDate'],
        'koreaIvc': value['koreaIvc'],
        'koreaOutboundDate': value['koreaOutboundDate'],
        'expectedOutboundDate': value['expectedOutboundDate'],
        'packageStatus': value['packageStatus'],
        'packageStatusCode': value['packageStatusCode'],
        'markNo': value['markNo'],
        'locationCode': value['locationCode'],
        'coupangInboundDate': value['coupangInboundDate'],
        'coupangWarehouseId': value['coupangWarehouseId'],
        'coupangWarehouseName': value['coupangWarehouseName'],
        'coupangMerchantName': value['coupangMerchantName'],
        'coupangInboundNo': value['coupangInboundNo'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'additionalServiceName': value['additionalServiceName'],
        'remark': value['remark'],
        'warehouseRemarkCN': value['warehouseRemarkCN'],
        'warehouseRemarkKR': value['warehouseRemarkKR'],
        'orderStatusName': value['orderStatusName'],
        'orderStatusCode': value['orderStatusCode'],
        'krLocalTransportMethodId': value['krLocalTransportMethodId'],
        'totalBoxCount': value['totalBoxCount'],
        'totalPalletCount': value['totalPalletCount'],
        'totalCBM': value['totalCBM'],
        'currentNationId': value['currentNationId'],
        'buyType': value['buyType'],
        'currentWarehouseId': value['currentWarehouseId'],
        'outboundPlanDate': value['outboundPlanDate'],
        'billType': value['billType'],
        'billTypeName': value['billTypeName'],
        'billStatus': value['billStatus'],
        'billStatusName': value['billStatusName'],
        'billCode': value['billCode'],
        'proxyBuyCancelOrderStatusName': value['proxyBuyCancelOrderStatusName'],
        'blNo': value['blNo'],
        'returnFromCoupangProcessMethod': value['returnFromCoupangProcessMethod'],
        'orderType': value['orderType'],
        'returnOutboundDate': value['returnOutboundDate'],
        'returnTrackingNumber': value['returnTrackingNumber'],
        'returnTransportMethod': value['returnTransportMethod'],
        'returnTransportMethodName': value['returnTransportMethodName'],
        'returnTruckNumber': value['returnTruckNumber'],
        'returnTruckContact': value['returnTruckContact'],
        'outboundTransportMethodId': value['outboundTransportMethodId'],
        'outboundTruckNumber': value['outboundTruckNumber'],
        'outboundTruckContact': value['outboundTruckContact'],
        'takeGoodsMethod': value['takeGoodsMethod'],
        'firstOrder': value['firstOrder'],
        'combinSplitFroms': value['combinSplitFroms'] == null ? undefined : ((value['combinSplitFroms'] as Array<any>).map(CombinSplitFromVoToJSON)),
        'createFromOrderId': value['createFromOrderId'],
        'createFromOrderCode': value['createFromOrderCode'],
        'createFromOrderRequestType': value['createFromOrderRequestType'],
        'therePlCancelOrderStatus': value['therePlCancelOrderStatus'],
        'therePlCancelOrderStatusName': value['therePlCancelOrderStatusName'],
        'applyValue': value['applyValue'],
        'applyUnit': value['applyUnit'],
        'realWeight': value['realWeight'],
        'requireBeforeAccept': value['requireBeforeAccept'],
        'returnFetchGoodsMethod': value['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': value['returnFetchGoodsCode'],
        'returnFetchGoodsDate': value['returnFetchGoodsDate'],
        'adminButtonCodes': value['adminButtonCodes'],
        'clientButtonCodes': value['clientButtonCodes'],
        'adminManualOrderStatusList': value['adminManualOrderStatusList'] == null ? undefined : ((value['adminManualOrderStatusList'] as Array<any>).map(ManualOrderStatusToJSON)),
        'goodsList': value['goodsList'] == null ? undefined : ((value['goodsList'] as Array<any>).map(OrderBigGoodsVoToJSON)),
        'boxPalletInfos': value['boxPalletInfos'] == null ? undefined : ((value['boxPalletInfos'] as Array<any>).map(BoxPalletInfoVoToJSON)),
        'koreaTracks': value['koreaTracks'] == null ? undefined : ((value['koreaTracks'] as Array<any>).map(OrderBigTableKoreaTrackVoToJSON)),
    };
}

